module.exports = __webpack_public_path__ + "img/1501.782e1cf0.jpg";